import React from 'react';
import getSubscriptionStatusLabel from '@dashboard/services/status/getSubscriptionStatusLabel';
import StatusBadge from '@dashboard/components/StatusBadge';
import Tooltip from '@dashboard/components/Tooltip';

export default function SubscriptionStatusBadge({ status, livemode, error }) {
  if (!livemode) {
    return <StatusBadge status="test" label="Test" />;
  }

  if (status === 'abandoned') {
    return <StatusBadge status="abandoned" label="Abandoned" />;
  }

  if (status === 'recovered') {
    return <StatusBadge status="recovered" label="Recovered" />;
  }

  const label = getSubscriptionStatusLabel(status);

  if (
    error &&
    status !== 'active' &&
    status !== 'trialing' &&
    status !== 'scheduled' &&
    status !== 'completed'
  ) {
    return (
      <Tooltip label={error} side="left">
        <StatusBadge status={status} label={label} withInfoIcon />
      </Tooltip>
    );
  }

  return <StatusBadge status={status} label={label} />;
}
